import { FileTypeIcon } from "../file-type-icon";
import { StatusCard } from "../status-card";
import { FileProperties } from "./file-properties";

interface UnsupportedViewerProps {
  properties: FileProperties;
}

export const UnsupportedViewer = ({ properties }: UnsupportedViewerProps) => {
  return (
    <StatusCard
      icon={<FileTypeIcon extension={properties.extension} />}
      title="Preview not available"
      description={`.${String(properties.extension || "").toLowerCase()} isn't supported for preview.`}
    />
  );
};
